export const relations = [
  { id: 'father', name: 'Father' },
  { id: 'mother', name: 'Mother' },
  { id: 'brother', name: 'Brother' },
  { id: 'sister', name: 'Sister' },
  { id: 'spouse', name: 'Spouse' },
];
